import { Check } from 'lucide-react';

/** Plan-tier comparison cards shown next to the signup form. */
export function AuthPlanTiers() {
  return (
    <div className="lg:pt-2" data-testid="auth-tier-info">
      <h3 className="font-heading text-lg text-[#F2F2F2] mb-1">Pick a plan that fits your production</h3>
      <p className="text-[#A0A0A0] font-body text-sm mb-5">Start free. Upgrade anytime.</p>

      <div className="space-y-3">
        {/* Free */}
        <div className="bg-[#151515] rounded-xl p-4 border border-white/[0.06]" data-testid="tier-free">
          <div className="flex items-baseline justify-between mb-1.5">
            <p className="font-heading text-base text-[#F2F2F2]">Free</p>
            <div>
              <span className="text-[#F2F2F2] font-heading text-xl">$0</span>
              <span className="text-[#555555] font-body text-xs ml-1">/ forever</span>
            </div>
          </div>
          <p className="text-[#A0A0A0] font-body text-xs leading-relaxed">
            1 project · Basic planning · Shot list · Limited exports
          </p>
        </div>

        {/* Pro */}
        <div className="bg-[#151515] rounded-xl p-4 border-2 border-[#D6B36A]/40 relative" data-testid="tier-pro">
          <div className="absolute -top-2.5 left-4 bg-[#D6B36A] text-[#0D0D0D] text-[10px] font-body font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider">Best Value</div>
          <div className="flex items-baseline justify-between mb-1.5 mt-1">
            <p className="font-heading text-base text-[#D6B36A]">Pro</p>
            <div>
              <span className="text-[#D6B36A] font-heading text-xl">$20</span>
              <span className="text-[#A0A0A0] font-body text-xs ml-1">for 3 mo · then $10/mo</span>
            </div>
          </div>
          <ul className="space-y-1.5 mt-2">
            <li className="text-[#F2F2F2] font-body text-xs flex items-start gap-2"><Check className="w-3 h-3 text-[#D6B36A] mt-0.5 shrink-0" /> Unlimited projects &amp; script management</li>
            <li className="text-[#F2F2F2] font-body text-xs flex items-start gap-2"><Check className="w-3 h-3 text-[#D6B36A] mt-0.5 shrink-0" /> Unlimited script breakdown tagging + PDF</li>
            <li className="text-[#F2F2F2] font-body text-xs flex items-start gap-2"><Check className="w-3 h-3 text-[#D6B36A] mt-0.5 shrink-0" /> Call sheet email delivery + weather</li>
            <li className="text-[#F2F2F2] font-body text-xs flex items-start gap-2"><Check className="w-3 h-3 text-[#D6B36A] mt-0.5 shrink-0" /> Standard PDF exports</li>
          </ul>
        </div>

        {/* Pro+ */}
        <div className="bg-[#151515] rounded-xl p-4 border border-purple-400/30" data-testid="tier-proplus">
          <div className="flex items-baseline justify-between mb-1.5">
            <p className="font-heading text-base text-purple-400">Pro+</p>
            <div>
              <span className="text-purple-400 font-heading text-xl">$15</span>
              <span className="text-[#A0A0A0] font-body text-xs ml-1">/month · teams &amp; live productions</span>
            </div>
          </div>
          <ul className="space-y-1.5 mt-2">
            <li className="text-[#F2F2F2] font-body text-xs flex items-start gap-2"><Check className="w-3 h-3 text-purple-400 mt-0.5 shrink-0" /> Everything in Pro</li>
            <li className="text-[#F2F2F2] font-body text-xs flex items-start gap-2"><Check className="w-3 h-3 text-purple-400 mt-0.5 shrink-0" /> Team collaboration (up to 4)</li>
            <li className="text-[#F2F2F2] font-body text-xs flex items-start gap-2"><Check className="w-3 h-3 text-purple-400 mt-0.5 shrink-0" /> Drag-and-drop calendar</li>
            <li className="text-[#F2F2F2] font-body text-xs flex items-start gap-2"><Check className="w-3 h-3 text-purple-400 mt-0.5 shrink-0" /> Real-time expense tracking</li>
            <li className="text-[#F2F2F2] font-body text-xs flex items-start gap-2"><Check className="w-3 h-3 text-purple-400 mt-0.5 shrink-0" /> Advanced exports + priority support</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
